import { action, makeObservable, observable } from 'mobx';
import { Store } from '../../../store/store';
import { StoreNode } from '../../../store';
import { LoginFormState } from './loginFormState';

type AuthLoginPageMode = 'poster' | 'plain';
export class LoginPageState
  extends StoreNode {

  layout: AuthLoginPageMode = 'poster';

  constructor(store: Store) {
    super(store);
    makeObservable(this, {
      layout: observable,
      attached: action,
      detached: action,
    });
  }

  readonly form = new LoginFormState(this.store);

  attached() { /* noop */ }

  detached() {
    this.form.reset();
  }
}